import { useLocation } from "react-router-dom";
import Categories from "./Categories";
import Catalog from "./CatalogProducts";
import Products from "./Products";
import CategoriesData from "../../data/categories/categoriesData"; 

export default function MarketplaceRouter() {
  const location = useLocation();
  const pathParts = location.pathname
    .replace(/^\/marketplace\/?/, "")
    .split("/")
    .filter(Boolean);

  if (pathParts.length === 0) {
    return (
      <Categories
        node={{ category: "Marketplace", subCategories: CategoriesData }}
      />
    );
  }

  let node = null;
  let currentLevel = CategoriesData;
  let i = 0;

  while (i < pathParts.length) {
    const part = decodeURIComponent(pathParts[i]).toLowerCase();
    const next = currentLevel.find(
      (n) => (n.slug ?? "").toLowerCase() === part
    );
    if (!next) break;
    node = next;
    currentLevel = node.subCategories || [];
    i++;
  }

  if (!node) return <div>404 - Not found</div>;

  const remainder = pathParts.slice(i);
  const hasChildren =
    Array.isArray(node.subCategories) && node.subCategories.length > 0;

  if (remainder.length > 0) {
    return <Products productId={remainder.at(-1)} />;
  }

  if (hasChildren) {
    return <Categories node={node} />;
  }

  return <Catalog catalog={node} />;
}
